/* eslint-disable */
import React from 'react';
import { Helmet } from 'react-helmet';

import { populate, pathReducer } from 'ggApp/utils/pathBuilder';
import loadConfiguration from 'ggApp/utils/configuration';
import { getAlternateLinkStores } from 'staticStoreConfig';

const { APP_CONFIG } = loadConfiguration();
const { shopHost: host } = APP_CONFIG;

export default class AlternateLocaleLink extends React.Component {
    getAlternateLink = (store, langCode) => {
        if (store === undefined || !store.countryCode) return null;
        const { routes, params } = this.props;
        const parameterizedPath = pathReducer(routes);
        const path = populate(parameterizedPath, {
            ...params,
            store: store.storeCode,
            language: langCode.toLowerCase(),
        });
        return (
            <link
                key={`${langCode}-${store.countryCode.toUpperCase()}`}
                rel="alternate"
                href={`${host}${path}`}
                hrefLang={`${langCode}-${store.countryCode.toUpperCase()}`}
            />
        );
    };

    render() {
        return (
            <Helmet>
                {getAlternateLinkStores().reduce((prev, current) => {
                    if (!current || !current.countryCode) return prev.concat([]);
                    const alternateLinks = current.languages.map(
                        (lang) => this.getAlternateLink(current, lang),
                    );
                    return prev.concat(alternateLinks);
                }, [])}
            </Helmet>
        );
    }
}
